import { addMutator } from '@poa/state';
import moment from 'moment';

import { 
  fetchDashboard, 
  fetchNewDashboard, 
  fetchSuccess, 
  fetchFailed, 
  fetchExpandableSuccess,
  fetchDataSuccess, 
  fetchProfitSuccess,
  fetchCalendarSuccess,
  fetchUsersSuccess,
  fetchClientsSuccess,
  setDates } from './dashboard.actions';

// fetch
addMutator(fetchDashboard, (payload, { store }) => {
  store.dashboard.meta.isLoading = true;
  store.dashboard.meta.hasError = false;

  store.dashboard.dataLoading = true;
  store.dashboard.profitLoading = true;
  store.dashboard.calendarLoading = true;
  store.dashboard.usersLoading = true;
  store.dashboard.clientsLoading = true;
});

addMutator(fetchNewDashboard, (payload, { store }) => {
  store.dashboard.meta.isLoading = true;
  store.dashboard.meta.hasError = false;

  store.dashboard.dataLoading = true;
  store.dashboard.profitLoading = true;
  store.dashboard.calendarLoading = true;
  store.dashboard.usersLoading = true;
  store.dashboard.clientsLoading = true;
});


addMutator(fetchSuccess, (payload, { store }) => {
  store.dashboard.meta.isLoading = false;
  store.dashboard.meta.hasError = false;
  store.dashboard.meta.loaded = true;
});


addMutator(fetchDataSuccess, ({ data, reportsPrevious }, { store }) => {
  store.dashboard.data = data;
  store.dashboard.dataPrevious = reportsPrevious;
  store.dashboard.dataLoading = false;
});

addMutator(fetchProfitSuccess, ({ profitData, profitReportPrevious }, { store }) => {
  store.dashboard.profitData = profitData;
  store.dashboard.profitDataPrevious = profitReportPrevious;
  store.dashboard.profitLoading = false;
});

addMutator(fetchCalendarSuccess, ({ calendarData }, { store }) => {
  store.dashboard.calendarData = calendarData;
  store.dashboard.calendarLoading = false;
});

addMutator(fetchUsersSuccess, ({ dashboardUsers }, { store }) => {
  store.dashboard.dashboardUsers = dashboardUsers;
  store.dashboard.usersLoading = false;
});

addMutator(fetchClientsSuccess, ({ dashboardClients }, { store }) => {
  store.dashboard.dashboardClients = dashboardClients;
  store.dashboard.clientsLoading = false;
});


addMutator(fetchExpandableSuccess, ({ data }, { store }) => {
  store.dashboard.meta.isLoading = false;
  store.dashboard.meta.hasError = false;
  const userId = parseInt(data.data[0].index);
  const element = store.dashboard.calendarData.data.find(item => item.index === userId);

  if (element) {
    element.team_leads = data.data[0].team_leads;
  }
  store.dashboard.meta.loaded = true;
});

addMutator(fetchFailed, (payload, { store }) => {
  store.dashboard.meta.isLoading = false;
  store.dashboard.meta.hasError = true;
});

addMutator(setDates, ({ startDate, endDate }, { store }) => {

  if (startDate) {
    store.dashboard.filters.startDate = moment(startDate).utc();
  }

  if (endDate) {
    store.dashboard.filters.endDate = moment(endDate).utc();
  }
});
